<span
  class="inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-xs font-medium"
  [ngClass]="colourClasses()"
  >{{ status() | titlecase }}</span
>
